import { __url } from '../../absoluteUrls/absoluteUrlTranslations';
import { DS_BRIEF_BASE_URL, DS_BRIEF_CREATE_URL, DS_BRIEF_MULTI_STEP_URL } from '../consts';

export function getBriefBaseUrl() {
    return __url(`${DS_BRIEF_BASE_URL}`);
}

export function getBriefMultiStepUrl(id?: string) {
    const baseUrl = __url(`${DS_BRIEF_MULTI_STEP_URL}`);
    if (id) {
        return `${baseUrl}/${id}?step=1`;
    }
    return baseUrl;
}

export function getBriefCreateURL(mpvID?: string, productKey?: string) {
    const path = `${DS_BRIEF_CREATE_URL}/${productKey ?? 'other-design'}`;
    const mpvIDParam = mpvID ? `?mpvId=${mpvID}` : '';
    return `${__url(path)}${mpvIDParam}`;
}
